module.exports = __webpack_public_path__ + "img/tree-01-h-leaves.1305565a.png";